import { configureStore, combineSlices, EnhancedStore } from '@reduxjs/toolkit';
import { isDevelopment } from './constants';
import { baseApiAuthenticated } from '@/api/v2';
import { widgetManifestApi } from '@/api/v2/widgets';
import { authMiddleware } from '@/middleware/authMiddleware';
// RTK Query middleware must be registered at store creation — there is no
// lazy path for it — so the assistant api is wired explicitly.
import { assistantApi } from '@starjack/entities/assistantConfig';
import { registerStore } from '@starjack/api';
import { authSlice } from '@starjack/features/authentication';
import { pageDataSlice } from '@starjack/features/pageData';

export const rootReducer = combineSlices(
    baseApiAuthenticated,
    authSlice,
    pageDataSlice,
    assistantApi,
    widgetManifestApi
);

// Wrap with clearAuthData logic
const finalReducer = (state, action) => {
    if (action.type === 'authSlice/clearAuthData') {
        return {
            ...rootReducer(undefined, action),
        };
    }

    return rootReducer(state, action);
};

export type Store = NonNullable<Parameters<typeof rootReducer>[0]>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const store: EnhancedStore<Store, any, any> = configureStore({
    reducer: finalReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).concat(
            authMiddleware,
            baseApiAuthenticated.middleware,
            assistantApi.middleware,
            widgetManifestApi.middleware
        ),

    devTools: isDevelopment,
});

// fetchAuthWrapper reads the token from here
registerStore(store);
